// rangeLow is included, rangeHigh is not
export const BUCKETS = [
  {
    id: 1,
    name: '<1',
    rangeLow: 0,
    rangeHigh: 1,
  },
  {
    id: 2,
    name: '1-2',
    rangeLow: 1,
    rangeHigh: 2,
  },
  {
    id: 3,
    name: '2-4',
    rangeLow: 2,
    rangeHigh: 4,
  },
  {
    id: 4,
    name: '4-8',
    rangeLow: 4,
    rangeHigh: 8,
  },
  {
    id: 5,
    name: '8-24',
    rangeLow: 8,
    rangeHigh: 24,
  },
  {
    id: 6,
    name: '24-36',
    rangeLow: 24,
    rangeHigh: 36,
  },
  {
    id: 7,
    name: '36-48',
    rangeLow: 36,
    rangeHigh: 48,
  },
  {
    id: 8,
    name: '48-72',
    rangeLow: 48,
    rangeHigh: 72,
  },
  {
    id: 9,
    name: '72-96',
    rangeLow: 72,
    rangeHigh: 96,
  },
  {
    id: 10,
    name: '96+',
    rangeLow: 96,
    rangeHigh: Number.MAX_SAFE_INTEGER,
  },
];

class OrderAgeBucket {
  constructor(id, name, rangeLow, rangeHigh) {
    this.id = id;
    this.name = name;
    this.rangeLow = rangeLow;
    this.rangeHigh = rangeHigh;
    this.count = 0;
  }

  addToCount(count) {
    this.count += count;
  }
}

export const bucketData = (datums) => {
  let datumIndex = 0;
  return BUCKETS.reduce((acc, bucket) => {
    const orderAgeBucket = new OrderAgeBucket(bucket.id, bucket.name, bucket.rangeLow, bucket.rangeHigh);
    while (datumIndex < datums.length && datums[datumIndex].age < orderAgeBucket.rangeHigh) {
      orderAgeBucket.addToCount(datums[datumIndex].count);
      datumIndex++;
    }
    return [...acc, orderAgeBucket];
  }, []);
};

const getTotalCount = (d) => {
  return d.reduce((acc, datum) => {
    return acc + datum.count;
  }, 0);
};

const getPercentage = (value, total) => {
  return (value * 100) / total;
};

// turns count value into a percentage
export const formatBucketedData = (buckets) => {
  const totalCount = getTotalCount(buckets);
  const reduced = buckets.reduce(
    (acc, bucket) => {
      const percentage = getPercentage(bucket.count, totalCount);
      return {
        transformedData: [
          ...acc.transformedData,
          {
            id: bucket.id,
            age: bucket.name,
            count: percentage,
          },
        ],
        maxPercentage: Math.max(percentage, acc.maxPercentage),
      };
    },
    {
      transformedData: [],
      maxPercentage: -Infinity,
    },
  );
  return [reduced.transformedData, reduced.maxPercentage];
};

const GRAPH_OFFSET = -0.5;

export const normalizeSla = (value) => {
  const match = BUCKETS.find((bucket) => value < bucket.rangeHigh);
  const multiple = 1 / (match.rangeHigh - match.rangeLow);
  const hoursOverLowerBound = value - match.rangeLow;
  const normalizedSla = match.id + GRAPH_OFFSET + hoursOverLowerBound * multiple;
  return Math.round(normalizedSla * 100) / 100;
};
